import { useState, useEffect, useCallback } from 'react'

interface UseUserEngagementReturn {
  tradeCount: number
  shouldShowSimplyStockBanner: boolean
  dismissSimplyStockBanner: () => void
  incrementTradeCount: () => void
}

const STORAGE_KEYS = {
  TRADE_COUNT: 'simulator_trade_count',
  BANNER_DISMISSED: 'simplystock_banner_dismissed'
}

export const useUserEngagement = (): UseUserEngagementReturn => {
  const [tradeCount, setTradeCount] = useState(0)
  const [bannerDismissed, setBannerDismissed] = useState(false)

  // Load data from localStorage on mount
  useEffect(() => {
    try {
      const savedTradeCount = localStorage.getItem(STORAGE_KEYS.TRADE_COUNT)
      const savedBannerDismissed = localStorage.getItem(STORAGE_KEYS.BANNER_DISMISSED)

      if (savedTradeCount) {
        setTradeCount(parseInt(savedTradeCount, 10) || 0)
      }

      if (savedBannerDismissed === 'true') {
        setBannerDismissed(true)
      }
    } catch (error) {
      console.error('Error loading user engagement data:', error)
    }
  }, [])

  // Increment trade count
  const incrementTradeCount = useCallback(() => {
    const newCount = tradeCount + 1
    setTradeCount(newCount)
    
    try {
      localStorage.setItem(STORAGE_KEYS.TRADE_COUNT, newCount.toString())
    } catch (error) {
      console.error('Error saving trade count:', error)
    }
  }, [tradeCount])

  // Dismiss banner permanently
  const dismissSimplyStockBanner = useCallback(() => {
    setBannerDismissed(true)
    
    try {
      localStorage.setItem(STORAGE_KEYS.BANNER_DISMISSED, 'true')
    } catch (error) {
      console.error('Error saving banner dismissal:', error)
    }
  }, [])

  // Determine if banner should be shown
  const shouldShowSimplyStockBanner = tradeCount >= 3 && !bannerDismissed

  return {
    tradeCount,
    shouldShowSimplyStockBanner,
    dismissSimplyStockBanner,
    incrementTradeCount
  }
}
